var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("TagsMultiselect", {
    attrs: {
      title: "Tags",
      value: _vm.tagsIdsFromDB,
      newTags: _vm.newTagsNames,
      disabled: _vm.disabled,
      max: _vm.max,
      withCustomTags: "",
      getcontainerStyle: _vm.getParentcontainerStyle,
    },
    on: { input: _vm.updateTagList, search: _vm.search },
    scopedSlots: _vm._u(
      [
        {
          key: "noResult",
          fn: function ({ currentSearchString }) {
            return [
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(currentSearchString)),
              ]),
              _vm._v(" - is already selected "),
            ]
          },
        },
        {
          key: "option",
          fn: function ({ option: tag, newTag }) {
            return [
              newTag
                ? _c("TagMultiselectItem", {
                    attrs: { labelText: _vm.customTagLabel, tagName: tag.name },
                  })
                : _vm._e(),
              _vm._t("default", null, { tags: _vm.tags }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }